import { render, staticRenderFns } from "./DirectionConfig.vue?vue&type=template&id=040aed1f"
import script from "./DirectionConfig.vue?vue&type=script&lang=js"
export * from "./DirectionConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports